import "../TrainingTheme.css";
import "../../components/Session.css";
import "./Exercise.css";
import "./ExerciseAddTheme.css";

export function ExerciseAddLayout({ children }) {
  return (
    <div className="training-theme-root exercise-add-page">{children}</div>
  );
}
